import { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";

import { useTheme } from "@mui/styles";
import { UploadFile } from "@mui/icons-material";
import uuid from "react-uuid";
import { useSnackbar } from "notistack";
import { saveTypeCurve } from "../reducers/typeCurveSlice";
import { addTypeCurve } from "../reducers/typeCurveSlice";


export const ImportTypeCurve = ({ importTypeCurve, setImportTypeCurveVisible, darkMode, userEmail }) => {
  
  const theme = useTheme();

  const [typeCurveLink, setTypeCurveLink] = useState("");  


  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();


  return (
    <Dialog 
      open={true} 
      onClose={() => {}}
      fullWidth={true}
      maxWidth="md"
      PaperProps={{
        style: {
          backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light']
        },
      }}
      elevation={0}
    >
      <DialogTitle id="form-dialog-title">Import Type Curve</DialogTitle>
      <DialogContent>
        <Typography>Import type curve from a link</Typography>
        <TextField
          autoFocus
          margin="normal"
          id="link"
          label="Type Curve Link"
          placeholder="Paste type curve link"
          type="text"
          fullWidth
          value={typeCurveLink || ""}
          variant="outlined"
          onChange={e => setTypeCurveLink(e.target.value)}
        />

        <div style={{marginTop: 20}}>
          <Typography>Import type curve from a file</Typography>
          <Button
            component="label"
            color={darkMode ? "inherit" : "primary"}
            style={{color: darkMode ? '#000' : '#fff', marginTop: 10}}
            variant="contained"  
            startIcon={<UploadFile />}
          >
            Upload type curve
            <input
              type="file"
              accept=".json"
              hidden
              onChange={e => handleImportTypeCurveFile(e)}
            />
          </Button>
        </div>
        
      </DialogContent>
      <DialogActions style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Button onClick={() => setImportTypeCurveVisible(false)} color={darkMode ? "inherit" : "primary"} style={{marginRight: 10}}>
          Cancel
        </Button>
        <Button onClick={() => handleTypeCurveImportClick()} color={darkMode ? "inherit" : "primary"}
          style={{color: darkMode ? '#000' : '#fff'}} variant="contained" disabled={typeCurveLink?.length === 0}
        >
          Import
        </Button>
      </DialogActions>
    </Dialog>
  );

  // FUNCTIONS
  function handleTypeCurveImportClick() {
    try {
      if (typeCurveLink?.length > 0) { // if link is provided
        handleImportTypeCurveLink(typeCurveLink);
        setImportTypeCurveVisible(false);
      };
    } catch (error) {
      console.log(error);
      return;
    };
  };

  async function handleImportTypeCurveLink(location) { // import type curve from a link
    try {
      console.log(`Importing type curve from ${location}...`);
  
      if (!location.length > 0) {
        return false;
      };

      const res = await fetch(location, {cache: "no-store"});
      const tc = await res.json();

      if (!tc) return;

      const newTypeCurve = {...tc, id: uuid(), public: false, createdBy: userEmail};
      dispatch(addTypeCurve(newTypeCurve));
      dispatch(saveTypeCurve(newTypeCurve));


    } catch (error) {
      console.log('Could not import type curve!');
      console.log(error);
      enqueueSnackbar('Could not load type curve', { variant: 'error' });
    };
  };
  
  function handleImportTypeCurveFile(e) { // import type curve from a .json file
    try {
      console.log('Importing type curve from a file...');
      let files = e.target.files;
  
      if (!files.length > 0) {
        return false;
      };
      
      let reader = new FileReader();
      
      reader.readAsText(files[0]);
      
      reader.onload = (event) => {
        let typeCurve = JSON.parse(event.target.result);
        if (!typeCurve) {
          enqueueSnackbar('Could not import type curve', { variant: 'error' });
          return;
        };
        const typeCurveId = uuid();
        typeCurve = {...typeCurve, id: typeCurveId, public: false, createdBy: userEmail}; // change type curve id to prevent overlap

        dispatch(saveTypeCurve(typeCurve));

        // if (socket && socket.readyState === 1) {
        //   socket.send(JSON.stringify({messageType: 'saveTypeCurve', typeCurve, fileName: typeCurve?.id, userEmail}));
        // };

        setImportTypeCurveVisible(false);
      };
    } catch (error) {
      console.log('Coudld not import FBA!');
      console.log(error);
      enqueueSnackbar('Could not import type curve', { variant: 'error' });
    };
  };
};